export default {
  CAP: "fc0fa822-733b-11e9-b768-0242ac120002",
  COLLAR: "b73cb246-733b-11e9-b768-0242ac120002",
  CORRIDOR: "addfa123-733b-11e9-b768-0242ac120002",
  SWAP: "fe1fa999-733b-11e9-b768-0242ac120002",
  ANY_LENDER_APPROVED: "cdefa777-733b-11e9-b768-0242ac120002",
  FLOOR: "a0449a2b-9d8b-11e9-8b5f-00ff12c3b408",
  list: [
    { name: "Cap", value: "fc0fa822-733b-11e9-b768-0242ac120002" },
    { name: "Swap", value: "fe1fa999-733b-11e9-b768-0242ac120002" },
    { name: "Corridor", value: "addfa123-733b-11e9-b768-0242ac120002" },
    { name: "Collar", value: "b73cb246-733b-11e9-b768-0242ac120002" },
    { name: "Any Lender Approved", value: "cdefa777-733b-11e9-b768-0242ac120002" },
    { name: "Floor", value: "a0449a2b-9d8b-11e9-8b5f-00ff12c3b408" }
  ]
};

export const hedgeTypes = [
  { name: "Cap", value: "fc0fa822-733b-11e9-b768-0242ac120002" },
  { name: "Swap", value: "fe1fa999-733b-11e9-b768-0242ac120002" },
  { name: "Corridor", value: "addfa123-733b-11e9-b768-0242ac120002" },
  { name: "Collar", value: "b73cb246-733b-11e9-b768-0242ac120002" },
  { name: "Any Lender Approved", value: "cdefa777-733b-11e9-b768-0242ac120002" },
  { name: "Floor", value: "a0449a2b-9d8b-11e9-8b5f-00ff12c3b408" }
];
export const hedgeTypesForTypeAhead = [
  { name: "Cap", value: "fc0fa822-733b-11e9-b768-0242ac120002" },
  { name: "Swap", value: "fe1fa999-733b-11e9-b768-0242ac120002" },
  { name: "Corridor", value: "addfa123-733b-11e9-b768-0242ac120002" },
  { name: "Collar", value: "b73cb246-733b-11e9-b768-0242ac120002" },
  { name: "Floor", value: "a0449a2b-9d8b-11e9-8b5f-00ff12c3b408" },
  { name: "Any Lender Approved", value: "cdefa777-733b-11e9-b768-0242ac120002" }
];
